<template>

  <!---->
  <div>
    <ShortCut></ShortCut>
    <LogoHome></LogoHome>
    <Navigation></Navigation>
    <div class="content-class">
      <div class="content-title-class">
        山东康成尔兴药业集团有限公司
      </div>
      <p>
        <img src="../image/introduction-img.png" align="left" width="420" hspace="5" vspace="5" class="img-content-class">
        &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp创建于2011年11月的山东康成尔兴药业集团有限公司，是鲁中地区较大的集仓储、物流、配送为一体的现代医药物流配送商，公司占地面积47亩，现有员工120人、执业药师2名、药师4名、药士6名，相关专业人员占员工总数的60%。业务覆盖整个鲁中地区并已和省内外各大厂家、商家建立了良好的业务往来，业绩逐年攀升，连续几年被淄博市评为A级纳税诚信企业，为百姓的健康做了很大的贡献。一颗医药领域里的新星正在鲁中大地上冉冉升起。
        <br/>
        &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp康为公司致力于全方位、多视角发展。逐步形成了以经营中药饮片、中成药、化学原料药、化学药制剂、抗生素、生化药品、生物制品、医疗器械、保健品等集仓储、批发、代理、配送、托管、医药物流于一体的经营格局。公司设有质管部、采购部、销售部、财务部、业务部、信息部、储运部、物流部物业部等部门，并按新药品法要求设立了立体货架仓库，总面积15000多平方米，配有电动叉车、冷风机组、制冷机组、除湿机、电子温湿度控制系统等设备，有符合要求的500立方米的冷库、冷藏运输车、保温箱，能够满足药品运输的冷链要求。具有专用的计算机和中央数据处理系统，对药品的进、销、存进行记录和管理，对药品质量情况能够及时准确地追溯。公司有完善的质量管理体系文件，药品的进、销、存全部经过严格的审核,保证了药品的质量。严谨、科学的质量方针和各项规章管理制度为公司的快速发展提供了有力保障。
        <br/>
        &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp几年来，公司秉承“康为医药，质量为本，诚信服务，合作共赢”的经营理念和“精细、零差、热诚、高效”的工作态度，树立了良好的信誉并创造了稳定的市场网络，为公司的发展打下了稳固的基础。
        <br/>
        &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp康为医药全体员工满怀热情和希望，立志将康为医药打造成鲁中地区最好的医药服务供应商，为百姓提供放心药。品质为上，呵护健康，客户至上是我们永远不变的承诺。
        <br/>
        &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp我们要继续坚守“诚信、规范、务实、创新”的原则，按药品法要求经营，夯实基础，锐意进取，把康为做大、做强，为每一位员工家庭生活品质的提高做贡献，为每一位合作者提供发展的空间。公司目前解决就业300多人，员工待遇高于同行业水平，实行岗位工资制、工龄加薪制、年底双薪制、绩效提成、休法定节假日、双休日、交七项劳动保险、按国家规定发放降暑费，免费午餐、满五年出国游等人性化管理体制，充分调动大家的积极性为公司的发展献计献策。公司致力于为每一位员工提供良好的工作和学习环境。注重对员工进行科学系统的技能培训，让每一位员工都能掌握一门专业技术，为公司的发展提供了人才保障。
        <br/>
        &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp新时代的康为医药，韬光养晦，蓄势待发，像搏击长空的雄鹰，像医药浪潮中开足马力的舰艇，载满阳光和希翼，载满康为人服务社会的决心，向着未来，向着巅峰，向着更高更远更亮的远方，披荆斩棘，奋勇前进。
        <br/>
        &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp责任于中、诚信于行、以心换心、以德昌兴，团结协力，共创辉煌。
        <br/>
        &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp让我们为稳健发展中的康为医药喝彩！
        <br/>
        &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp
        发展中的康为医药
        <br/>
        ●山东康成尔兴药业集团有限公司成立于2011年。
        <br/>
        ●2012-2013年全体康为人共同度过了公司最艰难的时期。
        <br/>
        ●连续多年被评为淄博市A级纳税诚信企业。
        <br/>
        ●公司目前解决就业300多人，员工待遇高于同行业水平，实行岗位工资制、工龄加薪制、年底双薪制、绩效提成、休法定节假日、双休日、交七项劳动保险、按国家规定发放降暑费，免费午餐、满五年出国游等，员工待遇正逐步提高。
        <br/>
        ●货物的进、销、存全部按药品管理法严格审核并可追溯，良好的质量管理体系保证了产品质量，完善的售后服务促进了公司发展和壮大。
        <br/>
        ●科学严谨的管理制度为公司的快速发展提供了有力保障。
        <br/>
        ●我们坚守“质量为本，康为百姓，诚信服务，合作共赢”的经营理念和“精细、零差、热
        诚、高效”的工作态度，建立了良好的信誉和稳定的市场，经过几年的努力和拼搏，我们满
        怀热情和希望，立志将康为医药打造成鲁中地区最好的医药服务供应商，为百姓提供优质
        的产品和优秀的服务是我们永远不变的承诺。
        <br/>
        ●我们将继续努力，夯实基础，锐意进取，一往无前，把康为做大、做强，为每一位员工家
        庭生活品质的提高做贡献，为每一位合作者提供发展的空间。
        <br/>
        ●现在销售额10个亿左右，纳税300多万。
        <br/>
        ●公司注重公益事业，2021年为重庆石柱县红十字会捐赠药品价值50多万；2022年03月份为周村红十字会捐赠1800套防护服，价值10多万；2022年04月份为吉林市慈善总会捐赠人民币100万，2022年05月为博山区红十字会捐赠药品8万多元。
      </p>
    </div>
  </div>
</template>

<script>
import ShortCut from '../component/ShortCut'
import Notice from "../component/Notice";

import Navigation from "../component/Navigation";
import LogoGroup from "../component/LogoGroup";
import LogoHome from "../component/LogoHome";
export default {
  name: "Introduction"
  ,
  components: {
    ShortCut,
    LogoHome,
    Navigation
  },
  data() {
    return {}
  },
  methods: {},
  mounted() {

  }
}
</script>

<style scoped>
.content-class{
  margin-left: 15%;
  margin-top: 2%;
  font-family: cursive;
  font-size: 20px;
  width: 70%;
}
.content-class>p{
  text-align: left;
}
.content-title-class{
  font-size: 30px;
}
.img-content-class{
  padding-right: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Introduction.vue